import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const PanelContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	flex-direction: column;
	gap: 20px;
	padding: 40px 30px 30px;
	border-radius: 10px;
	background-color: rgba(17, 19, 20, 0.98);
	border: 1px solid rgba(255, 255, 255, 0.1);
`;

const FormContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	margin-top: 10px;
`;

const ButtonContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

const ButtonContainerWrap = styled.div`
	display: flex;
	gap: 20px;
	width: 400px;
	flex-wrap: wrap;
`;

const FormBottomHintContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;

	${Text} {
		font-size: 14px;
		line-height: 16px;
		color: #ffffff;
	}
`;

export {
	PanelContainer,
	FormContainer,
	ButtonContainer,
	ButtonContainerWrap,
	FormBottomHintContainer,
};
